import { useTheme } from '@ori-ui/mui';
import { useWindowSize } from '@ori/presentation-hooks';

export const useIsMobile = () => {
  const { width } = useWindowSize();
  const { breakpoints } = useTheme();

  return width !== 0 && width < breakpoints.values.md;
};
